
		<base-support-modal [title]="title" [btnOkClass]="'btn-warning'" [btnOkLabel]="'Установить'" (onOk)="ok()">
			<p>Включить пользователя {{ this.title }} в фильтр "Исключить из статистики"?</p>
		</base-support-modal>
	